<template>
    <!--   </v-container>-->
    <v-sheet style="background-color:#fff;height:100%">
        <v-app-bar
            app
            dense
            fixed
            elevate-on-scroll
            style="border-bottom:1px solid #ddd; padding:0px; "
            elevation="0"
        >
            <v-btn :to="{name:'cotacaomensal'}" icon text dark>
                <v-icon color="black">arrow_back</v-icon>
            </v-btn>

            <v-toolbar-title>Cotação Mensal / {{$route.params.partner}} - {{$route.params.partner_service}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items></v-toolbar-items>
        </v-app-bar>

        <v-card elevation="0">
            <v-card-subtitle>
                Atualize o valor das cotações e adicione corretamente a data.
                <br />
O valor fica passível de alteração até que o crédito seja liberado(credito_liberado) para os usuários.
            </v-card-subtitle>
            <v-data-table
                :footer-props="{itemsPerPageOptions:[50,100,200]}"
                :headers="headers"
                :items="items"
            >
                <!-- total do relatório -->
                <template v-slot:item.total_report="{ item }">
                    <money disabled v-model="item.total_report" v-bind="$globalformmasks.money_2p"></money>
                </template>
                <!-- total recebido em moeda -->
                <template v-slot:item.total_received="{ item }">
                    <money
                        disabled
                        v-model="item.total_received"
                        v-bind="$globalformmasks.money_2p"
                    ></money>
                </template>
                <!-- diferenca em % entre o relatório e o pago efetivamente -->
                <template v-slot:item.received_n_report_diff="{ item }">
                    <money
                        disabled
                        v-model="item.received_n_report_diff"
                        suffix="%"
                        v-bind="$globalformmasks.money_9p"
                    ></money>
                </template>

                <!-- total em BRL na conta -->
                <template v-slot:item.total_received_brl="{ item }">
                    <money
                        disabled
                        v-model="item.total_received_brl"
                        v-bind="$globalformmasks.money_2p"
                    ></money>
                </template>

                <!-- Taxa bancária -->
                <template v-slot:item.bank_tax="{ item }">
                    <money disabled v-model="item.bank_tax" v-bind="$globalformmasks.money_2p"></money>
                </template>

                <!-- cotação real negociada com o banco -->
                <template v-slot:item.currency_rate_bank="{ item }">
                    <money
                        disabled
                        v-model="item.currency_rate_bank"
                        v-bind="$globalformmasks.money_9p"
                    ></money>
                </template>

                <!-- cotação efetiva relativa ao valor declarado no relatório eo o valor pago em real na conta -->
                <template v-slot:item.currency_rate_fair="{ item }">
                    <money
                        disabled
                        v-model="item.currency_rate_fair"
                        v-bind="$globalformmasks.money_9p"
                    ></money>
                </template>

                <!-- coluna de ações -->
                <template v-slot:item.actions="{ item }">
                    <!-- só habilitamos a edição se não tiver sido liberado o crédito -->
                    <template v-if="item.appliedto_base_analitico!==true">
                        <v-btn icon text @click="open_dialog_edita(item)">
                            <v-icon class="mr-2" outline>edit</v-icon>
                        </v-btn>
                        <v-btn
                            v-show="item.currency_rate_fair>0"
                            icon
                            text
                            @click="aplica_cotacao(item)"
                        >
                            <v-icon class="mr-2" outline>arrow_circle_down</v-icon>
                        </v-btn>
                    </template>
                </template>
            </v-data-table>
        </v-card>

        <v-dialog v-if="edita_dialog" :value="true" v-model="edita_dialog" max-width="500px" eager>
            <v-card>
                <v-card-title>Edição - Período: {{item_to_edit.i_date}} - Moeda: {{item_to_edit.s_currency}}</v-card-title>

                <v-card-text>
                    <v-alert
                        dense
                        outlined
                        type="warning"
                        v-if="(['',0,'0'].indexOf(item_to_edit.currency_rate_bank)<0)"
                    >Caso você altere uma cotação que já tenha sido definida é necessário refazer a liberação do crédito.</v-alert>

                    <!--v-text-field v-money="$globalformmasks.money_2p" :prefix="item_to_edit.s_currency" v-model.lazy="item_to_edit.total_report" label="Total do relatório"></v-text-field>
                    <money v-model="item_to_edit.total_report" v-bind="$globalformmasks.money_2p"></money-->

                    <vcurrencyfield
                        :prefix="item_to_edit.s_currency"
                        v-model.lazy="item_to_edit.total_report"
                        label="Total do relatório"
                    ></vcurrencyfield>
                    <vcurrencyfield
                        :prefix="item_to_edit.s_currency"
                        v-model="item_to_edit.total_received"
                        label="Total recebido em moeda"
                    ></vcurrencyfield>
                    <vcurrencyfield
                        prefix="R$"
                        v-model="item_to_edit.total_received_brl"
                        label="Total recebido em real"
                    ></vcurrencyfield>
                    <vcurrencyfield
                        prefix="R$"
                        v-model="item_to_edit.bank_tax"
                        label="Taxa bancária"
                    ></vcurrencyfield>                   
                    
                    <vcurrencyfield
                        prefix="R$"
                        :precision="9"
                        v-model="item_to_edit.currency_rate_bank"
                        label="Valor da cotação"
                    ></vcurrencyfield>

                    <!---->
                    <v-dialog
                        ref="dialog"
                        v-model="payment_date_modal"
                        :return-value.sync="item_to_edit.payment_date"
                        persistent
                        width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="item_to_edit.payment_date"
                                label="Data do Pagamento"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="item_to_edit.payment_date" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="payment_date_modal = false">Cancelar</v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.dialog.save(item_to_edit.payment_date)"
                            >OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                    <!---->

                    <template v-if="block_save">
                        <v-alert dense type="error">
                            O (valor recebido em moeda X o valor da cotação ) está dando uma diferença maior que 2 centavos.
                            <br />Por favor confira a cotação ou o valor recebido em real.
                            <br />
                            <vcurrencyfield
                                disabled
                                prefix="R$"
                                :precision="2"
                                :value="item_to_edit.total_received * item_to_edit.currency_rate_bank"
                                label
                            ></vcurrencyfield>
                        </v-alert>
                    </template>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="edita_dialog = false">Fechar</v-btn>
                    <v-btn
                        color="primary"
                        :disabled="block_save"
                        @click="save_cotacao(item_to_edit)"
                    >Salvar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- MODAL -->
        <modalmessage ref="modal" />
        <!--/MODAL -->
    </v-sheet>
</template>

<script>
import CotacaoService from "../../../../app/rest/cotacao";
import modalmessage from "../../../../components/shared/modalmessage";
import vcurrencyfield from "../../../../components/shared/visual/vcurrencyfield";

var cotacaoService = null;

export default {
    components: {
        modalmessage,
        vcurrencyfield
    },
    data: () => ({
        estimativa_valor_recebido: 0,
        block_save: false,
        edita_dialog: false,
        search: "",
        item_to_edit: { payment_date: null, currency_rate_bank: 0 },
        payment_date_modal: false,
        items: [],
        headers: [
            {
                text: "Período",
                align: "left",
                sortable: false,
                value: "i_date"
            },
            { text: "Moeda", value: "s_currency" },
            { text: "Relatório (TR)", value: "total_report" },
            { text: "Recebido moeda (TRM)", value: "total_received" },
            { text: "Desconto na fonte %", value: "received_n_report_diff" },
            { text: "Recebido na conta BRL", value: "total_received_brl" },
            { text: "Taxa bancária", value: "bank_tax" },
            { text: "Cotação", value: "currency_rate_bank" },
            { text: "Cotação efetiva", value: "currency_rate_fair" },
            { text: "Data Pagamento", value: "payment_date" },

            { text: "Ações", value: "actions" }
        ]
    }),
    beforeMount: function() {
        cotacaoService = CotacaoService.build();
        this.load_information();
    },
    watch: {
        //observamos o valor do cambio e calculamos se o valor que estamos recebendo está correto
        "item_to_edit.currency_rate_bank": function() {
            this.valida_valor_recebido();
        },
        "item_to_edit.total_received_brl": function() {
            this.valida_valor_recebido();
        }
    },
    methods: {
        valida_valor_recebido() {
            if (
                this.item_to_edit.total_received > 0 &&
                this.item_to_edit.currency_rate_bank > 0
            ) {
                let tvalor =
                    Math.round(
                        this.item_to_edit.total_received *
                            this.item_to_edit.currency_rate_bank *
                            100
                    ) / 100;
                let valores_aceitaveis = [
                        tvalor,
                        tvalor + 0.01,
                        tvalor + 0.02,
                        tvalor - 0.01,
                        tvalor - 0.02                        
                    ].map(function(e){
                        return Math.round(e*100)/100;
                    });
                
                //deixamos uma pequena margem de erro de 2 centavos para cima ou para baixo                
                if ( valores_aceitaveis.indexOf(this.item_to_edit.total_received_brl) >= 0 ) {
                    this.block_save = false;
                } else {
                    this.block_save = true;
                }
            }
            else{
                 this.block_save = false;
            }
        },
        aplica_cotacao(item) {
            this.$store.dispatch("loading");
            item.s_partner = this.$route.params.partner;
            item.s_partner_company = this.$route.params.partner_service;
            this.edita_dialog = false;
            cotacaoService
                .apply_cotacao(item)
                .then(e => {
                    if (e.status == "ok") {
                        let total_registros = e.msg;
                        this.$refs.modal.show({
                            title: "Cotação aplicada",
                            message:
                                "A cotação efetiva deste registro foi aplicada em " +
                                total_registros +
                                " registros",
                            btn_1_text: "Entendi"
                        });
                        //this.load_information();
                    } else {
                        this.$refs.modal.show({
                            title: "Erro ao aplicar a cotação",
                            message: e.msg,
                            btn_1_text: "Entendi"
                        });
                    }
                })
                .catch(e => {
                    console.log(e);
                    this.$refs.modal.show({
                        title: "Erro ao aplicar a cotação #fatal",
                        message:
                            "Por favor verifique os dados digitados. " + e.msg,
                        btn_1_text: "Entendi"
                    });
                })
                .finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        save_cotacao(item) {
            this.$store.dispatch("loading");

            item.s_partner = this.$route.params.partner;
            item.s_partner_company = this.$route.params.partner_service;

            this.edita_dialog = false;
            cotacaoService
                .save_cotacao(item)
                .then(e => {
                    if (e.status == "ok") {
                        this.$refs.modal.show({
                            title: "Cotação salva",
                            message:
                                "Essa cotação teve as suas informações atualizadas",
                            btn_1_text: "Entendi",
                            btn_1_action: () => {
                                this.load_information();
                            }
                        });

                        //this.load_information();
                    } else {
                        this.$refs.modal.show({
                            title: "Erro ao salvar a cotação",
                            message: "Por favor verifique os dados digitados.",
                            btn_1_text: "Entendi",
                            btn_1_action: () => {
                                this.load_information();
                            }
                        });
                    }
                })
                .catch(e => {
                    this.$refs.modal.show({
                        title: "Erro ao salvar a cotação",
                        message:
                            "Por favor verifique os dados digitados. " + e.msg,
                        btn_1_text: "Entendi"
                    });
                })
                .finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        load_information() {
            this.$store.dispatch("loading");

            var item = {
                partner: this.$route.params.partner,
                partner_company: this.$route.params.partner_service
            };

            cotacaoService
                .get_one(item)
                .then(e => {
                    if (e.status == "ok") {
                        this.items = e.items.cotacoes;
                    }
                })
                .catch(e => {})
                .finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        open_dialog_edita(item) {
            this.item_to_edit = JSON.parse(JSON.stringify(item));
            this.edita_dialog = true;
        }
    }
};
</script>